export enum EStickerPopupControlsMode {
    STREAMER,
    VIEWER,
    SEND,
}
